module.exports = __webpack_public_path__ + "static/dp-5895a2db875da4451f2a9bdf38a73ccb.webp";